module.exports = __webpack_public_path__ + "static/media/icon-watch.06dd7ae6.svg";